
import { Preview } from 'vue-advanced-cropper';
import * as Routes from '@/../types/constants/web_client_user.routes';
import { Component, Mixins } from 'vue-property-decorator';
import Page from './Page.vue';
import AthleteVerifiedAssessmentsCard from '../components/profile/athlete/AthleteVerifiedAssessmentsCard.vue';
import AthleteSelfAssessmentsCard from '../components/profile/athlete/AthleteSelfAssessmentsCard.vue';
import ComingSoonCard from '../components/ui/ComingSoonCard.vue'
import EditOverlay from '../components/ui/EditOverlay.vue'
import TeamMiniCard from '../components/ui/TeamMiniCard.vue'
import StatsSummaryCard from '../components/profile/athlete/StatsSummaryCard.vue'
import { VuetifyMixin, BAIconsMixin, AuthMixin, MyAthleteMixin, AthleteRoutingMixin, StringsMixin, UpgradeNowMixin } from '@/mixins';
import { athleteProfile, imagesStore } from '../store';
import MindsetSvg from '../components/svg/MindsetSvg.vue'
import TacticalClipboardSvg from '../components/svg/TacticalClipboardSvg.vue'
import SurveySvg from '../components/svg/SurveySvg.vue'
import GraduateCapSvg from '../components/svg/GraduateCapSvg.vue'
import { AthleteProfileModel } from '../models/athlete/AthleteProfileModel';
import { AthleteAssessmentDataModel } from '../models/athlete/AthleteAssessmentDataModel';
import { SelfAssessmentModel } from '../models/athlete/SelfAssessmentModel';
import { Route } from 'vue-router';
import SubscriptionInfoProvider from '@/components/hoc/SubscriptionInfoProvider.vue';
import ProfilePictureUpload from '@/components/forms/ProfilePictureUpload.vue';
import AthleteScoutingReportsCard from "@/components/profile/athlete/AthleteScoutingReportsCard.vue";
import AthleteComparativeDataCard from "@/components/profile/athlete/AthleteComparativeDataCard.vue";
import AthleteEventsCard from "@/components/profile/athlete/AthleteEventsCard.vue";
import AthleteScheduleCard from "@/components/profile/athlete/AthleteScheduleCard.vue";
import WeblinksCard from "@/components/ui/WeblinksCard.vue"
import AthleteMindsetReportCard from "@/components/profile/athlete/AthleteMindsetReportCard.vue"
import AthleteHighlightReelCard from "@/components/profile/athlete/AthleteHighlightReelCard.vue";
import SharingSummaryCard from "@/components/ui/SharingSummaryCard.vue"
import RecruitingProfileInfoProvider from '@/components/hoc/RecruitingProfileInfoProvider.vue';
import { SportName, WebLink } from '@/../types';
import { BAPurchaseModel, TeamModel } from '@/models';
import { baPurchaseApi } from '@/api/BAPurchaseApi';
import { notificationStore } from '@/store';
import { athleteApi } from '@/api/AthleteApi';


@Component({
	components:{
		AthleteVerifiedAssessmentsCard,
		AthleteSelfAssessmentsCard,
		ComingSoonCard,
		EditOverlay,
		ProfilePictureUpload,
		Preview,
		StatsSummaryCard,
		Page,
		MindsetSvg,
		TacticalClipboardSvg,
		SurveySvg,
		GraduateCapSvg,
		TeamMiniCard,
		SubscriptionInfoProvider,
		AthleteEventsCard,
		AthleteScoutingReportsCard,
		AthleteComparativeDataCard,
		AthleteMindsetReportCard,
		AthleteHighlightReelCard,
		AthleteScheduleCard,
		RecruitingProfileInfoProvider,
		SharingSummaryCard,
		WeblinksCard,
	},
	async beforeRouteEnter(to, _, next){
		next((vm: AthleteDashboard) => {
			if(vm.TheAthleteId !== null){
				athleteProfile.getAthleteProfile(vm.TheAthleteId);
			}else{
				athleteProfile.getAthleteProfile(vm.$auth.athleteId);
			}
		});
	},
	async beforeRouteUpdate(_, __, next){
		if(this.TheAthleteId !== null){
			athleteProfile.getAthleteProfile(this.TheAthleteId);
		}else{
			athleteProfile.getAthleteProfile(this.$auth.athleteId);
		}
		next();
	},
})
export default class AthleteDashboard extends Mixins(VuetifyMixin, BAIconsMixin, AuthMixin, StringsMixin, MyAthleteMixin, AthleteRoutingMixin, UpgradeNowMixin) {
	SportName = SportName;
	showHelp: boolean = false;

	mounted() {
		this.showHelp = !athleteProfile.mindsetReport || !athleteProfile.athleteAssessmentData || !athleteProfile.selfAssessmentSummary;
	}

	expandMetric(metric: string, featureAvailable: boolean = false): void{
		if(this.AssessmentData === null) return;
		this.$router.push({
			name: Routes.AthleteComparativeDataSummary,
			params:{
				metric,
				athleteId: this.TheAthleteId,
				featureAvailable: featureAvailable as any
			}
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		}).catch(() => {});
		this.$vuetify.goTo(0);
	}

	get AvatarSize(): { size: number, borderSize: number } {
		if( this.IsMobile ) {
			return {
				size: 75,
				borderSize: 3,
			};
		}

		return {
			size: 150,
			borderSize: 6,
		}
	}

	async setProfilePhoto(pictureUrl: string): Promise<void>{
		imagesStore.setCache({id: this.AthleteProfile.id, url: pictureUrl});
		await athleteProfile.setAthleteProfilePicture({ athleteId: this.TheAthleteId, pictureUrl: pictureUrl});
	}

	get isPageLoading(): boolean{
		return this.IsAthleteLoading || !athleteProfile.AthleteProfileIsReady;
	}
	get AthleteProfileIsReady(): boolean{
		return athleteProfile.AthleteProfileIsReady;
	}
	get AthleteProfile(): AthleteProfileModel{
		return athleteProfile.athleteProfile;
	}
	get IsMyAthleteProfile(): boolean{
		return this.AthleteProfile.id === this.$auth.athleteId;
	}

	get HasContactInformation(): boolean {
		return( this.IsNotEmpty(this.AthleteProfile.Email) || this.IsNotEmpty(this.AthleteProfile.PhoneNumber) );
	}
	get IsContactIncomplete(): boolean {
		return( this.IsEmpty(this.AthleteProfile.Email) || this.IsEmpty(this.AthleteProfile.PhoneNumber) );
	}

	get AssessmentData(): AthleteAssessmentDataModel | null{
		return athleteProfile.athleteAssessmentData;
	}
	get SelfAssessmentData(): SelfAssessmentModel | null{
		return athleteProfile.selfAssessmentSummary;
	}

	viewTeam(team: TeamModel) {
		if( this.IsEmpty(team?.id) ) return;

		this.$router.push({
			name: Routes.AthleteTeamDashboard,
			params: {
				teamId: team.id,
			}
		});
	}
	joinTeam(): void{
		this.$router.push(this.RouteToJoinTeam(this.TheAthleteId));
	}

	get BrowseSchoolsRoute(): Partial<Route>{
		return {
			name: Routes.AthleteSchoolSearch,
			params:{
				athleteId: this.TheAthleteId,
			}
		}
	}
	browseSchools(): void{
		this.$router.push(this.BrowseSchoolsRoute);
	}

	async onCancelNextUrl(purchase: BAPurchaseModel) {
		await this.onCancelPendingPurchase([purchase]);

		await athleteApi.patch({id: this.athleteProfile.id, nextUrl: null})
		this.TheAthleteProfile.nextUrl = null;

	}
	async onCancelPendingPurchase(pendingPurchases: Array<BAPurchaseModel>) {
		if( this.IsEmpty(pendingPurchases) ) return;

		for( const purchase of pendingPurchases ) {
			const purchaseName = this.AthleteEvent(purchase.productId)?.name;
			const purchaseIndex = this.TheAthleteProfile.purchases.findIndex(p => p.id === purchase.productId);
			if( purchaseIndex >= 0 ) this.TheAthleteProfile.purchases.slice(purchaseIndex, 1);
			await baPurchaseApi.delete(purchase);
			notificationStore.snackbarShowSuccess(purchaseName);
		}

		this.goToEvent(pendingPurchases[0].productId);
	}

	onWeblinksSave(weblinks: Array<WebLink>) {
		athleteApi.patch({id: this.TheAthleteId, weblinks});
	}
}
